import { useState, useReducer, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { server } from "../../App";
import { Button, Form, Icon, Modal } from "semantic-ui-react";
import { columnDefsFRS, OptionsFRS, columnDefsFRS2, OptionsFRS2 } from "./GridParams/GridParams"
import SpeedDialComponent from "../SpeedDial/SpeedDialComponent"

import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import {
    initialState,
    reducer,
    ACTION,
} from "../../Reducer/InitialStateReducer"

function Fournisseurs() {

    const [showBtn, setshowBtn] = useState(false);
    const [showBtn2, setshowBtn2] = useState(false);
    const [dataFromServer, setDataFromServer] = useState([])
    const [dataFromServerProd, setDataFromServerProd] = useState([])
    const [produitForm, setProduitForm] = useState("")
    const [oneRowData, setOneRowData] = useState({
        nom_frs: "",
        tel_frs: "",
        tel_frs2: ""
    })
    const [oneRowData2, setOneRowData2] = useState({
        idProduits_Fournisseurs: "",
        nom_Produits_Frs: "",
        fk_id_Frs: ""
    })

    const [FRSData, setFRSData] = useState({
        nom_frs: "",
        tel_frs: "",
        tel_frs2: ""
    })

    function handleChange(evt) {
        const value = evt.target.value;
        setFRSData({
            ...FRSData,
            [evt.target.name]: value
        });
    }

    const [state, dispatch] = useReducer(reducer, initialState);

    const GetAllFRSprod = () => {

        return oneRowData?.id_frs ?
            axios
                .get(`${server}ProduitFourniRoutes/${oneRowData?.id_frs}`, {
                    headers: {
                        jwtoken: sessionStorage.token,
                    },
                })
                .then((response) => setDataFromServerProd(response.data)) : null
    };
    const GetAllFRS = () => {
        return axios
            .get(`${server}FournisseurRoutes`, {
                headers: {
                    jwtoken: sessionStorage.token,
                },
            })
            .then((response) => setDataFromServer(response.data));
    };

    useEffect(() => {

        GetAllFRS()
        GetAllFRSprod()

    }, [])
    useEffect(() => {

        GetAllFRSprod()

    }, [oneRowData?.id_frs])



    const CreateOneFRS2 = () => {
        let x = {}
        x.nom_Produits_Frs = produitForm
        x.fk_id_Frs = oneRowData?.id_frs


        return produitForm ? axios({
            method: "POST",
            responseType: "json",
            url: `${server}ProduitFourniRoutes`,
            data: x,
            headers: {
                jwtoken: sessionStorage.token,
            },
        })
            .then((response) => {
                toast.success("Successfully created", {
                    position: toast.POSITION.TOP_CENTER,
                });
                setDataFromServerProd(response.data)
                setProduitForm("")

                return response;
            })
            .catch(() =>
                toast.error("error", {
                    position: toast.POSITION.TOP_CENTER,
                })
            ) : null
    };
    const CreateOneFRS = () => {

        return FRSData.nom_frs ? axios({
            method: "POST",
            responseType: "json",
            url: `${server}FournisseurRoutes`,
            data: FRSData,
            headers: {
                jwtoken: sessionStorage.token,
            },
        })
            .then((response) => {
                toast.success("Successfully created", {
                    position: toast.POSITION.TOP_CENTER,
                });
                setDataFromServer(response.data)
                let y = {
                    nom_frs: "",
                    tel_frs: "",
                    tel_frs2: ""
                }
                setFRSData(y)

                return response;
            })
            .catch(() =>
                toast.error("error", {
                    position: toast.POSITION.TOP_CENTER,
                })
            ) : null
    };

    const onSelectionChanged2 = (e) => {
        if (e.api.getSelectedRows()[0] === undefined) {
            const emptyCheckbox = {
                idProduits_Fournisseurs: "",
                nom_Produits_Frs: "",
                fk_id_Frs: ""
            };
            setOneRowData2(emptyCheckbox)
            setshowBtn2(false)
        } else {
            let clientArray = e.api.getSelectedRows()[0];

            setOneRowData2(clientArray)
            setshowBtn2(true)
        }
    };
    const onSelectionChanged = (e) => {
        if (e.api.getSelectedRows()[0] === undefined) {
            const emptyCheckbox = {
                id_frs: "",
                nom_frs: "",
                tel_frs: "",
                tel_frs2: ""

            };
            setOneRowData(emptyCheckbox)
            setshowBtn(false)
        } else {
            let clientArray = e.api.getSelectedRows()[0];

            setOneRowData(clientArray)
            setshowBtn(true)
        }
    };

    const deletehandler2 = async () => {
        return oneRowData2?.idProduits_Fournisseurs ? await axios({
            method: "delete",
            responseType: "json",
            url: `${server}ProduitFourniRoutes/${oneRowData2.idProduits_Fournisseurs}/${oneRowData?.id_frs}`,
            headers: {
                jwtoken: sessionStorage.token,
            },
        })
            .then((response) => {
                setDataFromServerProd(response.data)
                setshowBtn2(false)
            })
            .catch((err) =>
                toast.error("error", {
                    position: toast.POSITION.TOP_CENTER,
                })
            ) : null
    };
    const deletehandler = async () => {
        await axios({
            method: "delete",
            responseType: "json",
            url: `${server}FournisseurRoutes/${oneRowData?.id_frs}`,
            headers: {
                jwtoken: sessionStorage.token,
            },
        })
            .then((response) => {
                setDataFromServer(response.data)
                setshowBtn(false)
            })
            .catch((err) =>
                toast.error("Je ne peux pas supprimer ce fournisseur car il a un ou plusieurs produit a son compte", {
                    position: toast.POSITION.TOP_CENTER,
                })
            );
    };
    const updatehandler2 = async ({ data }) => {
        await axios({
            method: "PUT",
            responseType: "json",
            url: `${server}ProduitFourniRoutes/${oneRowData2?.idProduits_Fournisseurs}`,
            data: data,
            headers: {
                jwtoken: sessionStorage.token,
            },
        })
            .then((response) => {
                setDataFromServerProd(response.data)

            })
            .catch((err) =>
                toast.error("error", {
                    position: toast.POSITION.TOP_CENTER,
                })
            );
    };
    const updatehandler = async ({ data }) => {
        await axios({
            method: "PUT",
            responseType: "json",
            url: `${server}FournisseurRoutes/${oneRowData?.id_frs}`,
            data: data,
            headers: {
                jwtoken: sessionStorage.token,
            },
        })
            .then((response) => {
                setDataFromServer(response.data)

            })
            .catch((err) =>
                toast.error("error", {
                    position: toast.POSITION.TOP_CENTER,
                })
            );
    };


    return (
        <>
            <h1 className="titrePatient">Fournisseurs</h1>
            <div className='fixingbtoon' style={{ textAlign: "center" }}>
                <Link to="/Stock">
                    <Button icon labelPosition='left' className="IconFixDopdown" color="black">
                        <Icon name='book' size='large' />
                        Stock
                    </Button>
                </Link>
                <Button
                    style={{
                        // paddingLeft: "0.8rem",
                        paddingBottom: "0.5rem",
                        marginBottom: " 0.3rem"
                    }}
                    color="green"
                    onClick={() => dispatch({ type: ACTION.OPEN, size: "small" })}
                >
                    <Icon name='add' size='large' />
                    Fournisseur
                </Button>
                <Modal
                    size={state.size}
                    open={state.open}
                    onClose={() => dispatch({ type: ACTION.CLOSE })}
                >
                    <Modal.Header>Ajouter un Fournisseur</Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Group widths='equal'>
                                <Form.Field>
                                    <label>Fournisseur</label>
                                    <input placeholder='First Name'
                                        value={FRSData.nom_frs}
                                        name="nom_frs"
                                        onChange={handleChange}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Tel</label>
                                    <input
                                        value={FRSData.tel_frs}
                                        type="text" maxLength={10} placeholder='Tel'
                                        onChange={handleChange}
                                        name="tel_frs"
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Tel 2</label>
                                    <input
                                        value={FRSData.tel_frs2}
                                        type="text" maxLength={10} placeholder='Tel 2'
                                        name="tel_frs2"
                                        onChange={handleChange}
                                    />
                                </Form.Field>

                            </Form.Group>


                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color="blue" onClick={() => dispatch({ type: ACTION.CLOSE })}>
                            Retour
                        </Button>
                        <Button positive onClick={CreateOneFRS}>
                            Valider
                        </Button>
                    </Modal.Actions>
                </Modal>







                <Button
                    style={{
                        // float: "right",
                        // paddingLeft: "0.8rem",
                        paddingBottom: "0.5rem",
                        marginBottom: " 0.3rem"
                    }}
                    disabled={!showBtn}
                    color="purple"
                    onClick={() => dispatch({ type: ACTION.OPEN2, size2: "small" })}
                >
                    <Icon name='add' size='large' />
                    Produit
                </Button>
                <Modal
                    size={state.size2}
                    open={state.open2}
                    onClose={() => dispatch({ type: ACTION.CLOSE2 })}
                >
                    <Modal.Header>Ajouter un produit</Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Group widths='equal'>
                                <Form.Field>
                                    <label>Produit</label>
                                    <input
                                        value={produitForm}
                                        required
                                        placeholder='Produit'
                                        name="nom_Produits_Frs"
                                        onChange={(e) => setProduitForm(e.target.value)}
                                    />
                                </Form.Field>
                            </Form.Group>


                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color="blue" onClick={() => dispatch({ type: ACTION.CLOSE2 })}>
                            Retour
                        </Button>
                        <Button positive onClick={CreateOneFRS2}>
                            Valider
                        </Button>
                    </Modal.Actions>
                </Modal>





                {!showBtn ?

                    <Button
                        disabled
                        style={{
                            // paddingLeft: "0.8rem",
                            paddingRight: "0.8rem",
                            paddingBottom: "0.5rem",
                            marginBottom: " 0.3rem"
                        }}
                        color="red">  <Icon name='delete' size='large' />Fournisseur</Button>
                    :
                    <Button
                        onClick={deletehandler}
                        style={{
                            // paddingLeft: "0.8rem",
                            paddingRight: "0.8rem",
                            paddingBottom: "0.5rem",
                            marginBottom: " 0.3rem"
                        }}
                        color="red">  <Icon name='delete' size='large' />Fournisseur</Button>

                }
                {!showBtn2 ?

                    <Button
                        disabled
                        style={{
                            // paddingLeft: "0.8rem",
                            // float: "right",
                            paddingRight: "0.8rem",
                            paddingBottom: "0.5rem",
                            marginBottom: " 0.3rem"
                        }}
                        color="red">  <Icon name='delete' size='large' />Produit</Button>
                    :
                    <Button
                        onClick={deletehandler2}
                        style={{
                            // paddingLeft: "0.8rem",
                            // float: "right",
                            paddingRight: "0.8rem",
                            paddingBottom: "0.5rem",
                            marginBottom: " 0.3rem"
                        }}
                        color="red">  <Icon name='delete' size='large' />Produit</Button>

                }

            </div>
            <div className='DisplayFlexAndOtherStuff'>
                <div
                    id="myGrid"
                    className="ag-theme-alpine"
                    style={{
                        height: "77vh",
                        width: "60%",
                        // flex: "1 1 auto",
                    }}
                >
                    <AgGridReact
                        rowData={dataFromServer}
                        animateRows={true}
                        sortingOrder={["desc", "asc", null]}
                        // onGridReady={onGridReady}
                        columnDefs={columnDefsFRS}
                        rowSelection={"single"}
                        onSelectionChanged={onSelectionChanged}
                        onCellValueChanged={updatehandler}
                        gridOptions={OptionsFRS}
                    //   onRowDoubleClicked={onRowDoubleClicked}
                    ></AgGridReact>


                </div>
                <div
                    id="myGrid"
                    className="ag-theme-alpine"
                    style={{
                        height: "77vh",
                        width: "40%",
                        // flex: "1 1 auto",
                    }}
                >
                    <AgGridReact
                        rowData={dataFromServerProd}
                        animateRows={true}
                        sortingOrder={["desc", "asc", null]}
                        // onGridReady={onGridReady}
                        columnDefs={columnDefsFRS2}
                        rowSelection={"single"}
                        onSelectionChanged={onSelectionChanged2}
                        onCellValueChanged={updatehandler2}
                        gridOptions={OptionsFRS2}
                    //   onRowDoubleClicked={onRowDoubleClicked}
                    ></AgGridReact>


                </div>
            </div>

            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <SpeedDialComponent />
        </>
    )
}

export default Fournisseurs